// extracted by mini-css-extract-plugin
module.exports = {"add-button":"StepInventory_add-button_3hF2G"};